<template>
  <div class="w-100">
    <div
      class="main-card d-flex p-a-16 align-items-center align-self-stretch justify-content-between"
      @click="handleCardClick"
    >
      <div
        class="its-texts d-flex flex-column align-items-start"
        style="gap: 8px"
      >
        <div class="d-grid align-items-center">
          <p class="f-Overpass f-16 f-w-600 my-0">{{ id }}</p>
          <p class="f-Overpass f-12 f-w-400 my-0 f-c-grey">
            {{ this.$moment(time).format("L") }}
          </p>
        </div>
        <div class="d-flex align-items-center" style="gap: 4px">
          <img src="../../../assets/icons/location.svg" alt="time" />
          <p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
            {{ outlet }}
          </p>
        </div>
      </div>

      <div
        class="d-flex flex-column justify-content-between align-items-center"
      >
        <p class="f-Overpass f-16 f-w-400 my-0 f-c-green">
          {{ displaySaldo(saldo) }}
        </p>
      </div>
    </div>
    <modalIn
      ref="modalIn"
      :idsnap_topup="detailEmoney.idpembelian_emoney"
      :created_at="detailEmoney.created_at"
      :topup="detailEmoney.quota"
      :gtopup="detailEmoney.saldo_akhir"
      :outlet="detailEmoney.outlet?.nama"
      :kota="detailEmoney.outlet?.kota"
    />
  </div>
</template>

<script>
import modalIn from "./modal/modalIn.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "cardIn",
  components: {
    modalIn,
  },
  props: {
    id: String,
    time: String,
    outlet: String,
    saldo: Number,
  },
  computed: {
    ...mapState("riwayat", {
      detailEmoney: "detailEmoney",
    }),
  },
  methods: {
    ...mapActions({
      getDetailTopUp: "riwayat/getDetailTopUp",
    }),

    async handleCardClick() {
      this.$refs.modalIn.open();
      let data = this.id;
      await this.getDetailTopUp(data);
    },
    displaySaldo(money) {
      const formattedMoney = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(money);

      return formattedMoney.replace(/\.00$/, "");
      //
    },
  },
};
</script>

<style scoped>
.main-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  margin-top: 16px;
}
</style>
